export default ({ fill = false }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path
                fill={fill ? '#1F1F1F' : ''}
                d="M12.3 16.6L12 16.375L11.7 16.6L5.3 21.4C4.97038 21.6472 4.5 21.412 4.5 21V5C4.5 3.61929 5.61929 2.5 7 2.5H17C18.3807 2.5 19.5 3.61929 19.5 5V21C19.5 21.412 19.0296 21.6472 18.7 21.4L12.3 16.6Z"
                stroke="#1F1F1F"
            />
        </g>
    </svg>
);
